import { Pipe, PipeTransform } from '@angular/core';
/**
 *Pipes which obfuscate Iban
 *
 * @export
 * @class IbanFormat
 * @implements {PipeTransform}
 */
@Pipe({
    name: 'ibanFormat'
})

export class IbanFormat implements PipeTransform {
    /**
   * @param  {string} iban
   */
    transform(input: string): string {
        if (!input) {
            return '';
        } else {
            return input.slice(0,4) + '*'.repeat(input.length - 8) + input.slice(input.length - 4, input.length);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/iban-format.pipe.ts